module.exports = __webpack_public_path__ + "static/media/appointment_slider_phone3.50b47fe2.png";